export enum REGISTRATION_MODE {
  AUTOMATIC = 'AUTOMATIC',
  AFTER_PAYMENT = 'AFTER_PAYMENT',
  MANUAL = 'MANUAL',
};
